import React, { useState, useEffect, useCallback, useRef } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import Tree from 'components/Tree';
import { setSidePanel } from 'reducers/sidePanel/actions';
import { RESOURCE_TYPES, SIDEPANEL_STATES } from 'utils/appConstants';
import Table from './Table';

const aggregatorsColumns = [
  {
    headerName: 'ID',
    field: 'aggregatorId'
  },
  {
    headerName: 'LFDI',
    field: 'lfdi'
  },
  {
    headerName: 'SFDI',
    field: 'sfdi'
  }
];

const AggregatorMapContainer = styled.div`
  display: flex;
  flex: 1;
  z-index: 1;
  height: 100%;
`;

const TableContainer = styled.div`
  border-right: 1px solid #cfd1d3;
  display: flex;
  height: 100%;
  width: 600px;
  min-width: 500px;
  overflow-y: auto;
  padding: 5px;
`;

const TreeContainer = styled.div`
  padding: 2.75em 1em;
`;

const AggregatorMap = ({ onRef }) => {
  const aggregators = useSelector(state => state.aggregator.aggregators);
  const sidepanel = useSelector(state => state.sidePanel);
  const dispatch = useDispatch();
  const [selectedAggregator, setSelectedAggregator] = useState(null);
  const [selectedOnMap, setSelectedOnMap] = useState(false);
  const sidePanelIsOpen = sidepanel.displaySidePanel;
  const aggregatorTableRef = useRef(null);

  useEffect(() => {
    if (
      sidepanel.entity === RESOURCE_TYPES.AGGREGATOR &&
      sidepanel.state === SIDEPANEL_STATES.READ &&
      sidepanel.id !== selectedAggregator
    ) {
      setSelectedAggregator(sidepanel.id);
      setSelectedOnMap(false);
    }
  }, [sidepanel.entity, sidepanel.state, sidepanel.id, selectedAggregator]);

  const onSelectAggregator = useCallback(
    row => {
      const { aggregatorId } = row.data;

      dispatch(
        setSidePanel({
          entity: RESOURCE_TYPES.AGGREGATOR,
          state: SIDEPANEL_STATES.READ,
          id: aggregatorId,
          selectedOnTreeMap: true
        })
      );
      setSelectedAggregator(aggregatorId);
      setSelectedOnMap(true);
    },
    [dispatch]
  );

  // If the sidepanel closes, deselect any selected items on the table
  useEffect(() => {
    if (aggregatorTableRef.current?.api && !sidePanelIsOpen) {
      aggregatorTableRef.current.api.clearFocusedCell();
    }
  }, [sidePanelIsOpen]);

  return (
    <AggregatorMapContainer>
      <TableContainer>
        <Table
          bigTitle="All Aggregators"
          ref={aggregatorTableRef}
          rowData={aggregators}
          columnDefs={aggregatorsColumns}
          width="500px"
          height="500px"
          onRowClicked={onSelectAggregator}
          requiresSelectedOnMap={true}
          selectedOnMap={selectedOnMap}
        />
      </TableContainer>
      <TreeContainer>
        <Tree
          onRef={onRef}
          resourceTab={RESOURCE_TYPES.AGGREGATOR}
          resourceId={selectedAggregator}
        />
      </TreeContainer>
    </AggregatorMapContainer>
  );
};

export default AggregatorMap;
